if (!customElements.get('quick-buy-drawer')) {
  customElements.define(
    'quick-buy-drawer',
    class QuickBuyDrawer extends HTMLElement {
      constructor() {
        super();
        this.overlay = this.querySelector('[data-quick-buy-overlay]');
        this.closeBtn = this.querySelector('[data-quick-buy-close]');
        this.content = this.querySelector('#QuickBuyDrawerContent');
        this.viewLink = this.querySelector('[data-quick-buy-view-link]');
        this.panel = this.querySelector('.quick-buy-drawer__panel');
        this.openedBy = null;

        this.overlay.addEventListener('click', () => this.close());
        this.closeBtn.addEventListener('click', () => this.close());
        this.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') this.close();
        });
      }

      open(productUrl, opener) {
        this.openedBy = opener;
        this.classList.add('active');
        document.body.classList.add('overflow-hidden');
        this.viewLink.href = productUrl;

        this.content.innerHTML =
          '<div class="quick-buy-drawer__loading"><svg class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="spinner__path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle></svg></div>';

        this.trapFocus(this.panel);

        fetch(productUrl)
          .then((r) => r.text())
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const productInfo = doc.querySelector('product-info');

            if (!productInfo) {
              this.close();
              window.location.href = productUrl;
              return;
            }

            this.preprocessHTML(productInfo);
            HTMLUpdateUtility.setInnerHTML(this.content, productInfo.outerHTML);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            this.setupFormHandler();
          })
          .catch(() => {
            this.close();
            window.location.href = productUrl;
          });
      }

      close() {
        this.classList.remove('active');
        document.body.classList.remove('overflow-hidden');

        setTimeout(() => {
          this.content.innerHTML = '';
        }, 300);

        this.removeTrapFocus();

        if (this.openedBy) {
          this.openedBy.focus();
          this.openedBy = null;
        }
      }

      preprocessHTML(productElement) {
        productElement.classList.forEach((cls) => {
          if (cls.startsWith('color-') || cls === 'gradient') {
            this.content.classList.add(cls);
          }
        });

        this.preventDuplicatedIDs(productElement);

        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialogs = productElement.querySelectorAll('modal-dialog');
        modalDialogs.forEach((m) => m.remove());

        productElement.setAttribute('data-update-url', 'false');

        const mediaImages = productElement.querySelectorAll('.product__media img');
        mediaImages.forEach((img) => {
          img.setAttribute(
            'sizes',
            '(min-width: 750px) 420px, 100vw'
          );
        });
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;
        if (!sectionId) return;

        const newId = `quickbuy-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(sectionId, newId);

        Array.from(productElement.attributes).forEach((attr) => {
          if (attr.value.includes(sectionId)) {
            productElement.setAttribute(attr.name, attr.value.replace(sectionId, newId));
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      setupFormHandler() {
        const form = this.content.querySelector('product-form');
        if (!form) return;

        form.addEventListener('submit', (e) => {
          const cartDrawer = document.querySelector('cart-drawer');
          const cartNotification = document.querySelector('cart-notification');

          if (cartDrawer || cartNotification) {
            setTimeout(() => {
              this.close();
            }, 300);
          }
        });
      }

      trapFocus(container) {
        const focusableElements = container.querySelectorAll(
          'button, [href], input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])'
        );
        if (focusableElements.length === 0) return;

        this._focusableFirst = focusableElements[0];
        this._focusableLast = focusableElements[focusableElements.length - 1];

        this._trapHandler = (e) => {
          if (e.key !== 'Tab') return;
          if (e.shiftKey) {
            if (document.activeElement === this._focusableFirst) {
              e.preventDefault();
              this._focusableLast.focus();
            }
          } else {
            if (document.activeElement === this._focusableLast) {
              e.preventDefault();
              this._focusableFirst.focus();
            }
          }
        };

        container.addEventListener('keydown', this._trapHandler);
        this._focusableFirst.focus();
      }

      removeTrapFocus() {
        if (this._trapHandler && this.panel) {
          this.panel.removeEventListener('keydown', this._trapHandler);
        }
      }
    }
  );
}
